import React, { useContext } from 'react';

import { MlifeAccountSetup } from './MlifeAccountSetup';
import { MlifeActivation } from './MlifeActivation';
import { MlifeActivationContext } from './MlifeActivationContext';
import { MlifeVerification } from './MlifeVerification';

export function MlifeActivationStepper() {
  const { step } = useContext(MlifeActivationContext);
  const steps = {
    activate: <MlifeActivation />,
    verify: <MlifeVerification />,
    accountSetup: <MlifeAccountSetup />,
  };

  return steps[step];
}
